<template>
  <PopOverMenu
    class="menu-dropdown"
    placement="left"
  >
    <template #target>
      <IconButton
        size="md"
        flair="soft"
        kind="transparent"
        aria-label="Storage actions"
      >
        <Icon name="mono-dots-vertical" />
      </IconButton>
    </template>

    <template #menu="{ closeMenu }">
      <CardSection>
        <ListItemWithState
          flair="soft"
          class="menu-dropdown--item"
          aria-label="Open storage details"
          @click.stop.prevent="
            () => {
              emit('details')
              closeMenu()
            }
          "
        >
          <template #prepend>
            <Icon
              class="menu-dropdown--item--icon"
              name="mono-info"
            />
          </template>
          <template #default>
            <span class="menu-dropdown--item--label">Open Storage Details</span>
          </template>
        </ListItemWithState>
        <ListItemWithState
          flair="soft"
          class="menu-dropdown--item"
          aria-label="Delete storage"
          @click.stop.prevent="
            () => {
              emit('delete')
              closeMenu()
            }
          "
        >
          <template #prepend>
            <Icon
              class="menu-dropdown--item-delete--icon"
              name="mono-close"
            />
          </template>
          <template #default>
            <span class="menu-dropdown--item-delete--label">Delete Storage</span>
          </template>
        </ListItemWithState>
      </CardSection>
    </template>
  </PopOverMenu>
</template>

<script lang="ts">
export default {
  name: 'StorageActions',
}
</script>

<script lang="ts" setup>
import IconButton from '@/uiKit/Button/IconButton.vue'
import Icon from '@/uiKit/Icon/Icon.vue'
import ListItemWithState from '@/uiKit/List/ListItemWithState.vue'

import PopOverMenu from '@/uiKit/PopOverMenu.vue'
import CardSection from '@/uiKit/Card/CardSection.vue'

const emit = defineEmits<{
  (e: 'details'): void
  (e: 'delete'): void
  (e: 'open'): void
  (e: 'close'): void
}>()
</script>

<style lang="scss" scoped>
.menu-dropdown {
  &--item {
    min-width: 170px;

    &-delete {
      &--icon,
      &--label {
        color: var(--color-text-critical);
      }
    }
  }
}
</style>
